import type { SavingsPointsData } from '../hooks/useGetSavingsPoints';
import { parseContactMonth } from './formatSavingsPoints';

export type SavingsPointsWidgetState =
  | '1'   // No finance requirements form
  | '2'   // Building points (default)
  | '2a'  // Below £10k minimum investment
  | '2c'  // Down payment ready, still building points
  | '2f'  // Fully divested
  | '3'   // Points done, down payment missing
  | '4'   // Ready & in queue
  | '5'   // Near contact (within 3 months)
  | '6a'  // DIP in progress (LETTER_SENT)
  | '6b'; // DIP expired

const MIN_INVESTMENT = 10000;

function isContactWithinThreeMonths(contactMonth: string | null): boolean {
  if (!contactMonth) return false;
  const contact = parseContactMonth(contactMonth);
  const threeMonthsFromNow = new Date();
  threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);
  return contact <= threeMonthsFromNow;
}

export function getSavingsPointsWidgetState(data: SavingsPointsData): SavingsPointsWidgetState {
  const totalInvestment = parseFloat(data.total_investment ?? '0');

  // Resolution order: 2f → 6a → 6b → 5 → 4 → 3 → 1 → 2a → 2c → 2
  if (totalInvestment <= 0 && data.savings_points_earned !== null) return '2f';

  if (data.dip_status === 'LETTER_SENT') return '6a';

  if (data.dip_status === 'EXPIRED') return '6b';

  if (
    data.has_enough_points &&
    data.has_down_payment_ready &&
    isContactWithinThreeMonths(data.contact_month)
  )
    return '5';

  if (data.has_enough_points && data.has_down_payment_ready) return '4';

  if (data.has_enough_points && !data.has_down_payment_ready) return '3';

  if (!data.has_fr_form) return '1';

  if (totalInvestment < MIN_INVESTMENT) return '2a';

  if (data.has_down_payment_ready) return '2c';

  return '2';
}
